var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocks = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 0.675903C31.0385 0.675903 40 9.63745 40 20.6756V21.3243C40 32.3625 31.0385 41.3241 20.0003 41.3241C8.96155 41.3246 0 32.3625 0 21.3243V20.6756C0 9.63745 8.96155 0.675903 19.9997 0.675903Z",
    fill: "#EACDA6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_30199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9613 29.801H12.3355C10.4968 29.801 9.00024 28.3044 9.00024 26.4657V15.3353C9.00024 13.4966 10.4968 12 12.3355 12H28.9613C30.8 12 32.2966 13.4966 32.2966 15.3353V26.4657C32.2966 28.3044 30.8 29.801 28.9613 29.801ZM12.3355 12.646C10.8523 12.646 9.6462 13.852 9.6462 15.3353V26.4657C9.6462 27.9489 10.8523 29.155 12.3355 29.155H28.9613C30.4445 29.155 31.6506 27.9489 31.6506 26.4657V15.3353C31.6506 13.852 30.4445 12.646 28.9613 12.646H12.3355Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2991 16.1906H9.32298C9.14443 16.1906 9 16.0462 9 15.8677C9 15.6891 9.14443 15.5447 9.32298 15.5447H28.2991C28.4777 15.5447 28.6221 15.6891 28.6221 15.8677C28.6221 16.0462 28.4777 16.1906 28.2991 16.1906Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7988 14.1031C12.7988 14.4208 12.5414 14.6782 12.2237 14.6782C11.9061 14.6782 11.6487 14.4208 11.6487 14.1031C11.6487 13.7855 11.9061 13.5281 12.2237 13.5281C12.5414 13.5281 12.7988 13.7855 12.7988 14.1031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8049 14.1031C14.8049 14.4208 14.5475 14.6782 14.2299 14.6782C13.9122 14.6782 13.6548 14.4208 13.6548 14.1031C13.6548 13.7855 13.9122 13.5281 14.2299 13.5281C14.5475 13.5281 14.8049 13.7855 14.8049 14.1031Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.812 14.1031C16.812 14.4208 16.5546 14.6782 16.2369 14.6782C15.9193 14.6782 15.6619 14.4208 15.6619 14.1031C15.6619 13.7855 15.9193 13.5281 16.2369 13.5281C16.5546 13.5281 16.812 13.7855 16.812 14.1031Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6458 24.8494C16.5823 24.8494 16.5178 24.8302 16.4624 24.7913L13.1772 22.5177C13.0898 22.458 13.0376 22.3588 13.0376 22.2528C13.0376 22.1467 13.0898 22.0471 13.1772 21.9879L16.4624 19.7143C16.6084 19.6136 16.811 19.6482 16.9106 19.7958C17.0124 19.9419 16.9757 20.1433 16.8291 20.244L13.9282 22.2523L16.8291 24.2605C16.9757 24.3612 17.0124 24.5626 16.9106 24.7087C16.8488 24.7998 16.7481 24.8483 16.6458 24.8483V24.8494Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6511 24.8491C24.5488 24.8491 24.448 24.8006 24.3862 24.7095C24.2844 24.5635 24.3212 24.362 24.4678 24.2613L27.3687 22.2531L24.4678 20.2449C24.3212 20.1442 24.2844 19.9427 24.3862 19.7967C24.4864 19.649 24.6895 19.6133 24.8344 19.7151L28.1196 21.9887C28.207 22.0484 28.2593 22.1476 28.2593 22.2536C28.2593 22.3597 28.207 22.4593 28.1196 22.5185L24.8344 24.7921C24.779 24.831 24.7145 24.8502 24.6511 24.8502V24.8491Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3469 26.5614C18.292 26.5614 18.2366 26.547 18.186 26.5177C18.0314 26.4286 17.9781 26.2315 18.0676 26.0774L22.6698 18.1059C22.7588 17.9503 22.9576 17.9002 23.11 17.9876C23.2646 18.0766 23.3179 18.2738 23.2283 18.4278L18.6262 26.3993C18.5665 26.5033 18.4578 26.5614 18.3469 26.5614Z",
    fill: "#FFF8E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_30199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2958,
    height: 17.801,
    fill: "#FFF8E1",
    transform: "translate(9 12)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocks, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/locks.92870f8a.svg";
export { ForwardRef as ReactComponent };